import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { User } from 'oidc-client-ts';
import { NGXLogger } from 'ngx-logger';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent implements OnInit {
  
  readonly authService = inject(AuthService)
  env: boolean = false
  isLoading: boolean = false

  currentUser: User | null = null

  constructor (
    private logger: NGXLogger
  ) {}

  ngOnInit(): void {
    this.env = environment.production
  }

  loginSSO(): void {
    this.isLoading = true
    this.authService.login().catch(err => {
      this.isLoading = false
      this.logger.error(err)
    })
  }
  
}
